<template>
    <el-dialog 
        :visible="openDialog"
        :close-on-click-modal="false"
        title="Import from Quote"
        append-to-body
        @close="closeDialog">

        <el-row class="mt-10">
            <el-col :span="24">
                <quote-search
                    @selected="quote_id = $event"
                ></quote-search>
            </el-col>
        </el-row>

        <span slot="footer" class="dialog-footer">
            <el-button 
                :disabled="processing" 
                @click="closeDialog"
            >
                Close
            </el-button>
            <el-button 
                :disabled="processing || ! quote_id"
                @click="process"
                type="success"
            >
                <i v-if="processing" class="fa fa-pulse fa-spinner"></i> Add hiring area
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import QuoteSearch from './../../../clients/Quotes/vue/quote-search.vue';

export default {
    components: { 
        QuoteSearch
    },
    props: {
        openDialog: { type: Boolean, required: true },
        areaId: { type: Number, required: true },
    },
    data() {
        return {
            quote_id: null,
            processing: false,
        };
    },
    methods: {
        process() {
            this.processing = true;
            this.errorMessage = null;

            axios.post(this.url(`admin/area/import-from-quote`), {
                area_id: this.areaId,
                quote_id: this.quote_id,
            })
            .then(response => {
                this.closeDialog();
                this.$emit('process');
            })
            .finally(() => { this.processing = false; });
        },
        closeDialog() {
            this.$emit('update:openDialog', false);
        },
    },
};
</script>

<style scoped>
.mt-10 {
    margin-top: 10px;
}
</style>